export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0046_thumb.1ebb8734.jpg";